export default __webpack_public_path__ + "static/media/RocketCompaniesLogo.191e516f.png";